/* tslint:disable */
/* eslint-disable */
/**
 * external-information-requests
 * Medicaid Pending document requests to family members, with the staff workspace and the family portal
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues, parseDate, parseDateTime, serializeDate, serializeDateTime } from '../runtime';
import type { ReminderOverrides } from './ReminderOverrides';
import {
    ReminderOverridesFromJSON,
    ReminderOverridesFromJSONTyped,
    ReminderOverridesToJSON,
    ReminderOverridesToJSONTyped,
} from './ReminderOverrides';

/**
 * 
 * @export
 * @interface UpdateRequestRequest
 */
export interface UpdateRequestRequest {
    /**
     * 
     */
    expected_revision: number;
    /**
     * 
     */
    title?: string;
    /**
     * 
     */
    message?: string | null;
    /**
     * 
     */
    due_at?: Date | null;
    /**
     * 
     */
    reminder_overrides?: ReminderOverrides;
}

/**
 * Check if a given object implements the UpdateRequestRequest interface.
 */
export function instanceOfUpdateRequestRequest(value: object): value is UpdateRequestRequest {
    if (!('expected_revision' in value) || value['expected_revision'] === undefined) return false;
    return true;
}

export function UpdateRequestRequestFromJSON(json: any): UpdateRequestRequest {
    return UpdateRequestRequestFromJSONTyped(json, false);
}

export function UpdateRequestRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateRequestRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'expected_revision': json['expected_revision'],
        'title': json['title'] == null ? undefined : json['title'],
        'message': json['message'] === undefined ? undefined : json['message'] === null ? null : json['message'],
        'due_at': json['due_at'] === undefined ? undefined : json['due_at'] === null ? null : (parseDateTime(json['due_at'])),
        'reminder_overrides': json['reminder_overrides'] == null ? undefined : ReminderOverridesFromJSON(json['reminder_overrides']),
    };
}

export function UpdateRequestRequestToJSON(json: any): UpdateRequestRequest {
    return UpdateRequestRequestToJSONTyped(json, false);
}

export function UpdateRequestRequestToJSONTyped(value?: UpdateRequestRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'expected_revision': value['expected_revision'],
        'title': value['title'],
        'message': value['message'],
        'due_at': value['due_at'] == null ? value['due_at'] : serializeDateTime(value['due_at']),
        'reminder_overrides': ReminderOverridesToJSON(value['reminder_overrides']),
    };
}

